import { Injectable } from '@angular/core';
import { CloudUser } from './cloud-user';

@Injectable({
  providedIn: 'root'
})
export class CloudUserStorageService {

  currentUser: CloudUser;

  constructor() { }


  clear() {
    this.currentUser = null;
  }
}
